module.exports = __webpack_public_path__ + "img/datahub-3.1d541159.png";